import { render, staticRenderFns } from "./MultiSelect.vue?vue&type=template&id=2a4a2182&scoped=true"
import script from "./MultiSelect.vue?vue&type=script&lang=ts"
export * from "./MultiSelect.vue?vue&type=script&lang=ts"
import style0 from "./MultiSelect.vue?vue&type=style&index=0&id=2a4a2182&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4a2182",
  null
  
)

export default component.exports